import { Body2 } from '@cointracker/styleguide';
import { Select, SelectItem } from '@cointracker/styleguide/src/Select/Select';
import { useBoundCalculatorStore } from '../../Calculator/store';
import { findCoinBySlug } from '../../Calculator/utils';
import { SelectLoading } from './SelectLoading';
import {
  cryptoCurrencyImage,
  selectItemContent,
  selectTrigger,
} from './TradeCalculator.css';

export const CoinSelect = ({ loading = false }: { loading?: boolean }) => {
  const coins = useBoundCalculatorStore((state) => state.coins);
  const selectedCoin = useBoundCalculatorStore((state) => state.selectedCoin);
  const isInit = useBoundCalculatorStore((state) => state.isInit);
  const action = useBoundCalculatorStore((state) => state.setSelectedCoin);

  if (loading || !isInit) return <SelectLoading />;

  return (
    <Select
      className={selectTrigger}
      onValueChange={(coin) => action(findCoinBySlug(coins, coin))}
      value={selectedCoin?.slug ?? undefined}
    >
      {coins.map((coin) => (
        <SelectItem key={coin.slug} value={coin.slug}>
          <div className={selectItemContent}>
            <img
              key={`Asset-${coin.slug}`}
              src={coin.iconUrlFromInfo}
              alt={`Asset ${coin.name}`}
              className={cryptoCurrencyImage}
            />
            <Body2>{coin.symbol}</Body2>
          </div>
        </SelectItem>
      ))}
    </Select>
  );
};
